import React from 'react';
import styles from './Footer.module.scss';
import { useNavigate } from 'react-router-dom';

export const NavigationLink = ({ text }) => {

  const navigate = useNavigate();

  // Map link text to paths
  const pathMap = {
    HOME: '/',
    ABOUT: '/about-us',
    'CONTACT US': '/support', // Assuming you have a contact page
  };

  const handleClick = () => {
    navigate(pathMap[text]);
  };

  return (
    <div className={styles.navItem} onClick={handleClick}>
      <div className={styles.navText}>{text}</div>
    </div>
  );
};